import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DeleteModal from "../../components/Common/DeleteModal";
import * as Yup from "yup";
import { useFormik } from "formik";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios"; import { handleAuthError } from "../../utils";
import withAuth from "../withAuth";
import { baseUrl } from "../../Network";
import { Badge, Col, Container, Form, Input, Label, Modal, ModalBody, ModalHeader, ModalFooter, Row, } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from 'xlsx';

import {
    BtnBold,
    BtnItalic,
    Editor,
    EditorProvider,
    Toolbar,
    BtnLink,
    BtnBulletList,
    BtnClearFormatting,
    BtnNumberedList,
    BtnStyles,
    BtnUndo,
    BtnRedo,
    BtnStrikeThrough,
    BtnUnderline
} from "react-simple-wysiwyg";
import UploadWidget from "../../Uploader";
import currency_country from "../../constants/currency_countries.json";
import { newFormatDate } from "../../utils";
import { usePagination } from "../../hooks/usePagination";
import PaginationControls from "../../components/Common/PaginationControls";
import { useConfirm } from "../../contexts/ConfirmContext";

const NoProgram = () => {
    const { showConfirm } = useConfirm();
    const [usersRaw, setUsersRaw] = useState([]);
    const [usersRawF, setUsersRawF] = useState([]);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [contact, setContact] = useState({});
    const [modal, setModal] = useState(false);
    const [modalSingle, setModalSingle] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [country, setCountry] = useState({});
    const [state, setState] = useState({});
    const [timezone, setTimezone] = useState({});
    const [privateParentOnly, setPrivateParentOnly] = useState(0);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [groupEmailData, SetGroupEmailData] = useState({ t: 0, s: "", b: "" });
    const [url, updateUrl] = useState(null);
    const [error, updateError] = useState();
    const [balKey, setBalanceKey] = useState({});
    const [balKeyEdit, setBalKeyEdit] = useState({});
    const [noteModal, setNoteModal] = useState(false);
    const [referedModal, setReferedModal] = useState(false);
    const [selectedParent, setSelectedParent] = useState(null);
    const [parentNotes, setParentNotes] = useState([]);
    const [newNote, setNewNote] = useState("");
    const [multiIDs, setMultiIDs] = useState([]);
    const [multiTargetIDs, setMultiTargetIDs] = useState({});
    const [assignModal, setAssignModal] = useState(false);
    const [secondary, setSecondary] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [referedParents, setReferedParents] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState(null);

    // Add this function to fetch all admins
    const fetchAdmins = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/all`);
            setAdmins(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error fetching admins:", error);
            toast.error("Failed to fetch admins");
        }
    };

    // Add this function to handle parent assignment
    const handleAssignParent = async () => {
        if (!selectedAdmin) {
            toast.error("Please select an admin");
            return;
        }

        try {
            const parentIds = multiIDs.length > 0 ? multiIDs : [selectedParent?.id];
            const url = secondary ? `${baseUrl}/admin/parent/secondary/assigned` : `${baseUrl}/admin/parent/assigned`
            await axios.post(url, {
                adminId: selectedAdmin,
                parentIds
            });

            toast.success(`Parent(s) assigned successfully`);
            setAssignModal(false);
            setSecondary(false)
            setSelectedAdmin(null);
            setMultiIDs([]); // Clear selection after assignment
            fetchUsers()
        } catch (error) {
            handleAuthError(error)
            console.error("Error assigning parent:", error);
            toast.error("Failed to assign parent(s)");
        }
    };

    // Add this function to toggle the assign modal
    const toggleAssignModal = (parent = null) => {
        setSelectedParent(parent);
        if (!admins.length) {
            fetchAdmins();
        }
        setAssignModal(!assignModal);
    };

    // Add this function to fetch parent notes
    const fetchParentNotes = async (parentId) => {
        try {
            const response = await axios.get(`${baseUrl}/admin/parent/note/${parentId}`);
            setParentNotes(response.data.data);
        } catch (error) {
            handleAuthError(error)
            console.error("Error fetching notes:", error);
            toast.error("Failed to fetch notes");
        }
    };

    // Add this function to handle adding a new note
    const handleAddNote = async () => {
        if (!newNote.trim()) {
            toast.error("Note cannot be empty");
            return;
        }

        try {
            await axios.post(`${baseUrl}/admin/parent/note`, {
                parentId: selectedParent.id,
                note: newNote
            });
            toast.success("Note added successfully");
            fetchParentNotes(selectedParent.id);
            toggleNoteModal();
            setNewNote("");
        } catch (error) {
            handleAuthError(error)
            console.error("Error adding note:", error);
            toast.error("Failed to add note");
        }
    };

    // Add this function to toggle the note modal
    const toggleNoteModal = (parent = null) => {
        setParentNotes([])
        setSelectedParent(parent);
        if (parent) {
            fetchParentNotes(parent.id);
        }
        setNoteModal(!noteModal);
    };

    useEffect(() => {
        document.title = "Parents | RYD Admin";
        fetchUsers().then(null);
    }, [modal]);

    function handleOnUpload(error, result, widget) {
        if (error) {
            updateError(error);
            widget.close({
                quiet: true
            });
            return;
        }
        updateUrl(result?.info?.secure_url);
    }

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/parent/inactive/all`);
            setUsersRaw(response.data.data);
            setUsers(response.data.data);
            setLoading(false);
        } catch (error) {
            handleAuthError(error)
            setLoading(false);
            console.error("Error:", error);
        }
    };

    const toggle = () => {
        setModal(!modal);
    };

    const toggleSingle = () => {
        setModalSingle(!modalSingle);
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            subject: "",
            message: "",
        },
        validationSchema: Yup.object({
            subject: Yup.string().required("Please enter the subject"),
            message: Yup.string().required("Please enter the message"),
        }),
    });

    const handleSendEmailAll = async (event) => {
        event.preventDefault();
        try {
            await axios.post(`${baseUrl}/admin/parent/send/all`, groupEmailData);
            toast.success("Email sent to all parents successfully");
            toggle();
        } catch (error) {
            handleAuthError(error)
            toast.error("Failed to send email to parents");
        }
    };

    const handleSendEmailSingle = async (event) => {
        event.preventDefault();
        try {
            const payload = {
                body: validation.values.message,
                subject: validation.values.subject,
            };
            if (url) payload.attachmentLink = url;
            const response = await axios.post(`${baseUrl}/admin/parent/send/${selectedUserId}`, payload);
            if (response.data?.status) {
                toast.success("Email sent to the parent successfully");
                toggleSingle();
            } else {
                toast.error(response.data?.message || "Failed to send email to the parent");
            }
        } catch (error) {
            handleAuthError(error)
            console.error("Error:", error);
            toast.error(error.response?.data?.message || "Failed to send email to the parent");
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSingleSendEmail = (userId) => {
        setSelectedUserId(userId);
        toggleSingle();
    };


    const groupEmail = (t, e) => {
        SetGroupEmailData({ ...groupEmailData, [t]: e.target.value })
    }

    //resolve all child names for parents
    const getAllChildName = (pData) => {
        if (pData?.children?.length > 0) {
            //fetch child name
            return pData.children.map(((child) => ({
                childNames: `${child?.firstName} ${child?.lastName}`,
                isActive: child.programs.filter(y => y.isPaid && !y.isCompleted).length > 0
            })))
        } else {
            return null
        }
    }

    const filteredUsersForTable = Array.isArray(users) ? users.filter((user) =>
        `${user.firstName} ${user.lastName} ${user.email} ${user.phone} ${user.country}`
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
    ) : [];

    const {
        paginatedData: paginatedUsers,
        currentPage,
        totalPages,
        totalItems,
        pageSize,
        showAll,
        handlePageChange,
        handlePageSizeChange,
        goToNextPage,
        goToPreviousPage,
        canPreviousPage,
        canNextPage,
        paginatedDataLength,
    } = usePagination(filteredUsersForTable, 20);

    const handleUserCredit = async (id) => {
        const confirmed = await showConfirm({ title: "Toggle wallet", message: "Are you sure you want to toggle user wallet?", variant: "primary" });
        if (confirmed) {
            const udp = {
                token: 'super+push-cmd',
                amount: balKey['key' + id] || 0
            }
            const dd = await axios.post(`${baseUrl}/admin/parent/credit/${id}`, udp);
            toast.info("User balance toggled successfully, reload to confirm");
            console.log(dd.data);
        }
    }

    const getReferredValue = (status) => {
        if (status === null) {
            return 'NO';
        } else {
            return 'YES';
        }
    };

    const getReferredColor = (status) => {
        if (status === null) {
            return 'danger';
        } else {
            return 'success';
        }
    };

    const getDndValue = (status) => {
        if (status === 0) {
            return 'OFF';
        } else {
            return 'ON';
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 0:
                return 'danger';
            case 1:
                return 'success';
        }
    };

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            // Select all items
            const allIDs = users.map(user => user.id);
            setMultiIDs(allIDs);
            toast.warn("All items have been added to the action list.");
        } else {
            setMultiIDs([])
            toast.error("All items have been removed from the action list.");
        }
    };

    const exportToExcel = () => {
        try {
            // Prepare data for export
            const exportData = users.map((user, index) => {
                const childNames = user?.children?.length > 0
                    ? user.children.map(child => `${child?.firstName} ${child?.lastName}`).join(', ')
                    : 'No Child';

                return {
                    'S/N': index + 1,
                    'Parent Name': `${user.firstName} ${user.lastName}`,
                    'Children Names': childNames,
                    'Email': user.email,
                    'Phone': user.phone,
                    'State': user.state,
                    'Country': user.country,
                    'Timezone': user.timezone,
                    'Balance': `${currency_country[user?.country] || ''}${user?.balance || 0}`,
                    'No. of Children': user?.children?.length || 0,
                    'DND Status': user.dnd === 0 ? 'OFF' : 'ON',
                    'Assigned To': user?.assignedTo ? user?.admin?.fullName : "Unassigned",
                    'Referred': user.referredBy === null ? 'NO' : 'YES',
                    'Total Referred': user?.totalReferred || 0,
                    'Privacy Mode': user.privacyMode ? "Private" : "Not Private",
                    'Created At': newFormatDate(user.createdAt)
                };
            });

            // Create workbook and worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(exportData);

            // Set column widths for better readability
            const columnWidths = [
                { wch: 5 },   // S/N
                { wch: 20 },  // Parent Name
                { wch: 30 },  // Children Names
                { wch: 25 },  // Email
                { wch: 15 },  // Phone
                { wch: 15 },  // State
                { wch: 15 },  // Country
                { wch: 20 },  // Timezone
                { wch: 12 },  // Balance
                { wch: 12 },  // No. of Children
                { wch: 12 },  // DND Status
                { wch: 20 },  // Assigned To
                { wch: 10 },  // Referred
                { wch: 12 },  // Total Referred
                { wch: 15 },  // Privacy Mode
                { wch: 20 }   // Created At
            ];
            worksheet['!cols'] = columnWidths;

            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Inactive Parents');

            // Generate filename with current date
            const currentDate = new Date().toISOString().split('T')[0];
            const filename = `inactive_parents_${currentDate}.xlsx`;

            // Save the file
            XLSX.writeFile(workbook, filename);

            // Show success message
            toast.success(`Excel file exported successfully: ${filename}`);
        } catch (error) {
            console.error('Error exporting to Excel:', error);
            toast.error('Failed to export Excel file');
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem={`Manage InActive Parent  (${users.length})`} />
                    <Row>
                        <Col lg="12">
                            <Row className="align-items-center">
                                <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                                    <div>
                                        <select
                                            className="form-control filter-control"
                                            onChange={(e) => {
                                                const status = Number(e.target.value);
                                                let filtered = usersRaw;

                                                if (status === 1) {
                                                    filtered = usersRaw.filter(r => r.referredBy === null);
                                                } else if (status === 2) {
                                                    filtered = usersRaw.filter(r => r.referredBy !== null);
                                                }

                                                setUsersRawF(filtered);
                                                setUsers(filtered);
                                            }}
                                        >
                                            <option value={0}>Select referrals</option>
                                            <option value={1}>Normal Parents</option>
                                            <option value={2}>Referred Parents</option>
                                        </select>
                                    </div>
                                    <div>
                                        <Input
                                            type="text"
                                            placeholder="Search"
                                            value={searchQuery}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={exportToExcel}
                                            disabled={users.length === 0}
                                        >
                                            <i className="mdi mdi-file-excel"></i> Export to Excel
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            onClick={() => toggle()}>
                                            <i className="mdi mdi-email-variant"></i> Message All
                                            Parents
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-light"
                                            onClick={() => toggleAssignModal()}
                                            disabled={multiIDs.length === 0}
                                        >
                                            <i className="mdi mdi-account-plus"></i> Assign
                                        </button>
                                    </div>
                                </div>

                                <p>
                                    Privacy
                                    Mode: {privateParentOnly === 0 ? "All Mode" : privateParentOnly === 1 ? "Private" : "Public"}
                                </p>
                            </Row>
                            <Row>
                                <Col xl="12" className={'divTable'}>
                                    {loading ? (
                                        <div className="text-center mt-5">
                                            <div
                                                className="spinner-border text-primary"
                                                role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : users.length === 0 ? (
                                        <div className="text-center mt-5">
                                            <h3>No data available</h3>
                                        </div>
                                    ) : (
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div style={{ width: 50 }} className={'align-middle'}>
                                                            <input
                                                                style={{ marginRight: 5 }}
                                                                type={'checkbox'}
                                                                onChange={e => handleSelectAllChange(e)}
                                                            />
                                                            All
                                                        </div>
                                                    </th>
                                                    <th>Parent Name</th>
                                                    <th>Children Name(s)</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>State</th>
                                                    {/*<th>Data Privacy</th>*/}
                                                    <th>Country</th>
                                                    <th>Timezone</th>
                                                    <th>Balance</th>
                                                    <th>No.Child</th>
                                                    <th>DND</th>
                                                    <th>Assigned_to</th>
                                                    <th>Referred</th>
                                                    <th>Total_Referred</th>
                                                    <th>Created_At</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(users) &&
                                                    paginatedUsers.map((user, index) => {
                                                        const globalIndex = showAll 
                                                            ? index 
                                                            : (currentPage - 1) * pageSize + index;
                                                        return (
                                                            <tr key={user.id || index}
                                                                style={{ backgroundColor: user?.privacyMode ? '#ffeff2' : '#fff' }}>
                                                                <td>
                                                                    <div style={{ width: 50 }} className={'align-middle'}>
                                                                        <input style={{ marginRight: 5 }} type={'checkbox'} checked={multiIDs.includes(user.id)}
                                                                            onClick={(d) => {
                                                                                //multiple selection push to array
                                                                                if (multiIDs.includes(user.id)) {
                                                                                    //remove from array
                                                                                    setMultiIDs(multiIDs.filter(i => i !== user.id))
                                                                                    toast.error(user?.firstName + " removed is been from the action list.")
                                                                                } else {
                                                                                    setMultiIDs([...multiIDs, user.id])
                                                                                    toast.warn(user?.firstName + " has been added to action list.")
                                                                                }
                                                                            }} />
                                                                        {globalIndex + 1}
                                                                    </div>
                                                                </td>
                                                                <td>{user.firstName} {user.lastName}</td>
                                                                <td style={{ width: 200 }}>
                                                                    <div
                                                                        style={{ whiteSpace: 'nowrap' }}>{(user?.children?.length > 0 && getAllChildName(user).map((x, i) =>
                                                                            <li style={{ fontWeight: !x.isActive ? 'normal' : 'bold' }}
                                                                                key={i}>{x.childNames}</li>)) ||
                                                                            <li>No Child</li>}</div>
                                                                </td>
                                                                <td>{user.email}</td>
                                                                <td>{user.phone}</td>
                                                                <td style={{ width: 20 }}>{user.state}</td>
                                                                {/*<td>{user.privacyMode ? "Private" : "Not Private"}</td>*/}
                                                                <td>{user.country}</td>
                                                                <td>{user.timezone}</td>
                                                                <td>
                                                                    {currency_country[user?.country]}
                                                                    <input
                                                                        readOnly={!balKeyEdit['key' + user.id]}
                                                                        multiple={false}
                                                                        type={'number'}
                                                                        defaultValue={user?.balance}
                                                                        value={balKey['key' + user.id]}
                                                                        style={{ borderWidth: 0, width: 80 }}
                                                                        onChange={e => setBalanceKey({ ['key' + user.id]: e.target.value })} />
                                                                    <Link
                                                                        style={{ display: !balKeyEdit['key' + user.id] ? 'none' : '' }}
                                                                        className="text-primary"
                                                                        to="#"
                                                                        onClick={() =>
                                                                            handleUserCredit(user.id)
                                                                        }>
                                                                        <i className="mdi mdi-check font-size-18"></i>
                                                                    </Link>
                                                                </td>
                                                                <td>{user?.children?.length}</td>
                                                                <td>
                                                                    <Badge color={getStatusColor(user.dnd)}>
                                                                        {getDndValue(user.dnd)}
                                                                    </Badge>
                                                                </td>
                                                                <td>{user?.assignedTo ? user?.admin?.fullName : "Unassigned"}</td>
                                                                <td>
                                                                    <Badge color={getReferredColor(user.referredBy)}>
                                                                        {getReferredValue(user.referredBy)}
                                                                    </Badge>
                                                                </td>
                                                                <td>{user?.totalReferred}</td>
                                                                <td>{newFormatDate(user.createdAt)}</td>
                                                                <td>
                                                                    <div className="d-flex gap-3">
                                                                        <Link
                                                                            title={"Send email to this parent"}
                                                                            className="text-primary"
                                                                            to="#"
                                                                            onClick={() =>
                                                                                handleSingleSendEmail(user.id)
                                                                            }>
                                                                            <i className="mdi mdi-email-variant font-size-18"></i>
                                                                        </Link>
                                                                        <Link
                                                                            title="Add note"
                                                                            className="text-info"
                                                                            to="#"
                                                                            onClick={() => toggleNoteModal(user)}>
                                                                            <i className="mdi mdi-note-plus font-size-18"></i>
                                                                        </Link>
                                                                        <Link
                                                                            title="Assign to admin"
                                                                            className="text-warning"
                                                                            to="#"
                                                                            onClick={() => toggleAssignModal(user)}
                                                                        >
                                                                            <i className="mdi mdi-account-arrow-right font-size-18"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    )}
                                    {Array.isArray(users) && filteredUsersForTable.length > 0 && (
                                        <PaginationControls
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            totalItems={totalItems}
                                            pageSize={pageSize}
                                            showAll={showAll}
                                            handlePageChange={handlePageChange}
                                            handlePageSizeChange={handlePageSizeChange}
                                            goToNextPage={goToNextPage}
                                            goToPreviousPage={goToPreviousPage}
                                            canPreviousPage={canPreviousPage}
                                            canNextPage={canNextPage}
                                            paginatedDataLength={paginatedDataLength}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Compose Email</ModalHeader>
                <ModalBody>
                    <Form onSubmit={validation.handleSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className={'mb-3'}>
                                    <Label className="form-label">Email Target</Label>
                                    <select value={groupEmailData.t} className={'form-control'}
                                        onChange={(e) => groupEmail("t", e)}>
                                        <option value={0}>With All Cohort Status</option>
                                        <option value={1}>With Active Cohort</option>
                                        <option value={2}>With No Active Cohort</option>
                                        <option value={3}>With Idle Cohort</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <Label className="form-label">Email Subject</Label>
                                    <Input
                                        name="subject"
                                        type="text"
                                        placeholder="Subject"
                                        onChange={(e) => groupEmail("s", e)}
                                        value={groupEmailData.s}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Label className="form-label">Email Body</Label>
                                    <EditorProvider>
                                        <Editor value={groupEmailData.b} onChange={(e) => groupEmail("b", e)}
                                            containerProps={{ style: { resize: 'vertical', height: 200 } }}>
                                            <Toolbar>
                                                <BtnBold />
                                                <BtnItalic />
                                                <BtnLink />
                                                <BtnBulletList />
                                                <BtnClearFormatting />
                                                <BtnNumberedList />
                                                <BtnStyles />
                                                <BtnUndo />
                                                <BtnRedo />
                                                <BtnStrikeThrough />
                                                <BtnUnderline />
                                            </Toolbar>
                                        </Editor>
                                    </EditorProvider>
                                    <UploadWidget onUpload={handleOnUpload}>
                                        {({ open }) => {
                                            function handleOnClick(e) {
                                                e.preventDefault();
                                                open();
                                            }

                                            return (
                                                <a style={{ marginTop: 5 }} href={'#'} onClick={handleOnClick}>
                                                    {(url) ? "Override attachment" : "Add attachment"}
                                                </a>
                                            )
                                        }}
                                    </UploadWidget>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={toggle}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="ms-2 btn btn-primary ml-2"
                                        onClick={handleSendEmailAll}>
                                        Send Email
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            <Modal isOpen={noteModal} toggle={toggleNoteModal} size="lg">
                <ModalHeader toggle={toggleNoteModal}>
                    Notes for {selectedParent?.firstName} {selectedParent?.lastName}
                </ModalHeader>
                <ModalBody>
                    <div className="notes-container">
                        {parentNotes.length > 0 ? (
                            <div className="notes-list mb-4">
                                {parentNotes.map((note, index) => (
                                    <div key={index} className="note-card mb-3 p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="note-admin">
                                                <i className="mdi mdi-account-circle me-2"></i>
                                                {note.admin?.fullName}
                                            </div>
                                            <div className="note-date text-muted">
                                                {newFormatDate(note.createdAt)}
                                            </div>
                                        </div>
                                        <div className="note-content p-2">
                                            {note.note}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-4 text-muted">
                                No notes yet for this parent
                            </div>
                        )}

                        <div className="add-note-section">
                            <h5 className="mb-3">Add New Note</h5>
                            <EditorProvider>
                                <Editor
                                    value={newNote}
                                    onChange={(e) => setNewNote(e.target.value)}
                                    containerProps={{ style: { resize: 'vertical', height: 150 } }}
                                >
                                    <Toolbar>
                                        <BtnBold />
                                        <BtnItalic />
                                        <BtnLink />
                                        <BtnBulletList />
                                        <BtnClearFormatting />
                                        <BtnNumberedList />
                                        <BtnUndo />
                                        <BtnRedo />
                                    </Toolbar>
                                </Editor>
                            </EditorProvider>
                            <div className="text-end mt-3">
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    onClick={() => {
                                        setNewNote("");
                                        toggleNoteModal();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleAddNote}
                                >
                                    Save Note
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={assignModal} toggle={toggleAssignModal}>
                <ModalHeader toggle={toggleAssignModal}>
                    {multiIDs.length > 0 ? `Assign ${multiIDs.length} Parents` : `Assign ${selectedParent?.firstName} ${selectedParent?.lastName}`}
                </ModalHeader>
                <ModalBody>
                    <div className="mb-3">
                        <Label className="form-label">Select Admin</Label>
                        <select
                            className="form-control filter-control"
                            onChange={(e) => {
                                const adminId = e.target.value;
                                setSelectedAdmin(adminId);
                                console.log(adminId)
                            }}
                        >
                            <option value="">Select an admin</option>
                            {admins.map(admin => (
                                <option key={admin.id} value={admin.id}>
                                    {admin.fullName}
                                </option>
                            ))}
                        </select>

                        <div className={'align-middle my-3'}>
                            <input
                                style={{ marginRight: 5 }}
                                type={'checkbox'}
                                onChange={e => setSecondary(true)}
                            />
                            As Secondary
                        </div>
                    </div>
                    <div className="text-end mt-4">
                        <button
                            type="button"
                            className="btn btn-secondary me-2"
                            onClick={toggleAssignModal}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAssignParent}
                            disabled={!selectedAdmin}
                        >
                            Assign
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalSingle} toggle={toggleSingle}>
                <ModalHeader toggle={toggleSingle}>Compose Email</ModalHeader>
                <ModalBody>
                    <Form onSubmit={validation.handleSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className="mb-3">
                                    <Label className="form-label">Email Subject</Label>
                                    <Input
                                        name="subject"
                                        type="text"
                                        placeholder="Subject"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.subject}
                                    />
                                </div>
                                <div className="mb-3">
                                    <Label className="form-label">Email Body</Label>
                                    <EditorProvider>
                                        <Editor name="message" onChange={validation.handleChange}
                                            value={validation.values.message}
                                            containerProps={{ style: { resize: 'vertical', height: 200 } }}>
                                            <Toolbar>
                                                <BtnBold />
                                                <BtnItalic />
                                                <BtnLink />
                                                <BtnBulletList />
                                                <BtnClearFormatting />
                                                <BtnNumberedList />
                                                <BtnStyles />
                                                <BtnUndo />
                                                <BtnRedo />
                                                <BtnStrikeThrough />
                                                <BtnUnderline />
                                            </Toolbar>
                                        </Editor>
                                    </EditorProvider>
                                    <UploadWidget onUpload={handleOnUpload}>
                                        {({ open }) => {
                                            function handleOnClick(e) {
                                                e.preventDefault();
                                                open();
                                            }

                                            return (
                                                <a style={{ marginTop: 5 }} href={'#'} onClick={handleOnClick}>
                                                    {(url) ? "Override attachment" : "Add attachment"}
                                                </a>
                                            )
                                        }}
                                    </UploadWidget>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={toggleSingle}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="ms-2 btn btn-primary ml-2"
                                        onClick={handleSendEmailSingle}>
                                        Send Email
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            <ToastContainer />
        </React.Fragment>
    );
};
export default withAuth(NoProgram);
